"use strict";
/**
 * ENUM MODULE
 * @module EnumModule
 */
var HTTP_METHOD;
(function (HTTP_METHOD) {
    HTTP_METHOD[HTTP_METHOD["GET"] = 0] = "GET";
    HTTP_METHOD[HTTP_METHOD["POST"] = 1] = "POST";
    HTTP_METHOD[HTTP_METHOD["PUT"] = 2] = "PUT";
    HTTP_METHOD[HTTP_METHOD["DELETE"] = 3] = "DELETE";
    HTTP_METHOD[HTTP_METHOD["PATCH"] = 4] = "PATCH";
})(HTTP_METHOD || (HTTP_METHOD = {}));
var EXERCISE_MODE;
(function (EXERCISE_MODE) {
    EXERCISE_MODE[EXERCISE_MODE["ACTIVE"] = 0] = "ACTIVE";
    EXERCISE_MODE[EXERCISE_MODE["PASSIVE"] = 1] = "PASSIVE";
    EXERCISE_MODE[EXERCISE_MODE["PASSIVE_MEASURE"] = 2] = "PASSIVE_MEASURE";
    EXERCISE_MODE[EXERCISE_MODE["ACTIVE_MEASURE"] = 3] = "ACTIVE_MEASURE";
})(EXERCISE_MODE || (EXERCISE_MODE = {}));
/**
 * @enum EXERCISE_RES_STATUS
 * @property {NATURE} 추가적인 설정이 없는 상태
 * @property {MANAGER_STOP} 의사가 임의로 운동을 중지시킨 경우
 * @property {MANAGER_ACCOMPLISHED} 의사가 임의로 완료를 시킨 경우
 */
var EXERCISE_RES_STATUS;
(function (EXERCISE_RES_STATUS) {
    EXERCISE_RES_STATUS[EXERCISE_RES_STATUS["NATURE"] = 0] = "NATURE";
    EXERCISE_RES_STATUS[EXERCISE_RES_STATUS["MANAGER_STOP"] = 1] = "MANAGER_STOP";
    EXERCISE_RES_STATUS[EXERCISE_RES_STATUS["MANAGER_ACCOMPLISHED"] = 2] = "MANAGER_ACCOMPLISHED";
})(EXERCISE_RES_STATUS || (EXERCISE_RES_STATUS = {}));
var EXERCISE_STATUS;
(function (EXERCISE_STATUS) {
    EXERCISE_STATUS[EXERCISE_STATUS["WAITING"] = 0] = "WAITING";
    EXERCISE_STATUS[EXERCISE_STATUS["TERMINATED"] = 1] = "TERMINATED";
    EXERCISE_STATUS[EXERCISE_STATUS["ACCOMPLISHED_MANUAL"] = 2] = "ACCOMPLISHED_MANUAL";
    EXERCISE_STATUS[EXERCISE_STATUS["ACCOMPLISHED_AUTO"] = 3] = "ACCOMPLISHED_AUTO";
    EXERCISE_STATUS[EXERCISE_STATUS["ON_PROGRESS"] = 4] = "ON_PROGRESS";
    EXERCISE_STATUS[EXERCISE_STATUS["CANCELED"] = 5] = "CANCELED";
})(EXERCISE_STATUS || (EXERCISE_STATUS = {}));
var POSITION;
(function (POSITION) {
    POSITION[POSITION["ERROR"] = 0] = "ERROR";
    POSITION[POSITION["ELBOW"] = 1] = "ELBOW";
    POSITION[POSITION["WRIST"] = 2] = "WRIST";
    POSITION[POSITION["KNEE"] = 3] = "KNEE";
    POSITION[POSITION["ANKLE"] = 4] = "ANKLE";
})(POSITION || (POSITION = {}));
const POSITION_TRANS = [
    {
        key: POSITION[POSITION.ERROR],
        trans: 'exercise.position.error',
    }, {
        key: POSITION[POSITION.ELBOW],
        trans: 'exercise.position.elbow',
    }, {
        key: POSITION[POSITION.WRIST],
        trans: 'exercise.position.wrist',
    }, {
        key: POSITION[POSITION.KNEE],
        trans: 'exercise.position.knee',
    }, {
        key: POSITION[POSITION.ANKLE],
        trans: 'exercise.position.Ankle',
    },
];
var DIRECTION;
(function (DIRECTION) {
    DIRECTION[DIRECTION["ERROR"] = 0] = "ERROR";
    DIRECTION[DIRECTION["LEFT"] = 1] = "LEFT";
    DIRECTION[DIRECTION["RIGHT"] = 2] = "RIGHT";
})(DIRECTION || (DIRECTION = {}));
const DIRECTION_TRANS = [
    {
        key: DIRECTION[DIRECTION.ERROR],
        trans: 'exercise.direction.error',
    }, {
        key: DIRECTION[DIRECTION.LEFT],
        trans: 'exercise.direction.left',
    }, {
        key: DIRECTION[DIRECTION.RIGHT],
        trans: 'exercise.direction.right',
    }
];
var EQUIPMENT;
(function (EQUIPMENT) {
    EQUIPMENT[EQUIPMENT["REBLESS_HOME"] = 1] = "REBLESS_HOME";
    EQUIPMENT[EQUIPMENT["REBLESS_PRO"] = 2] = "REBLESS_PRO";
})(EQUIPMENT || (EQUIPMENT = {}));
const GENDER_TRANS = {
    null: { trans: 'unset' },
    'M': { trans: 'patient.info.gender.male' },
    'F': { trans: 'patient.info.gender.female' }
};
/**
 * 통일 위해서 미사용 처리
 * 리포트 다이얼로그만 이 enum 값 사용 중임
 */
// enum BRAIN_LESION {
//     UNSET = 0,
//     GRADE1 = 1,
//     GRADE2 = 2,
//     GRADE3 = 3,
//     GRADE4 = 4,
//     GRADE5 = 5,
//     NEW01 = 6,
//     NEW02 = 7
// }
// const BRAIN_LESION_TRANS = [
//     {
//         key : BRAIN_LESION[BRAIN_LESION.UNSET],
//         trans : 'unit.brain_lesion.unset',
//     },{
//         key : BRAIN_LESION[BRAIN_LESION.GRADE1],
//         trans : 'unit.brain_lesion.grade1',
//     },{
//         key : BRAIN_LESION[BRAIN_LESION.GRADE2],
//         trans : 'unit.brain_lesion.grade2',
//     },{
//         key : BRAIN_LESION[BRAIN_LESION.GRADE3],
//         trans : 'unit.brain_lesion.grade3',
//     },{
//         key : BRAIN_LESION[BRAIN_LESION.GRADE4],
//         trans : 'unit.brain_lesion.grade4',
//     },{
//         key : BRAIN_LESION[BRAIN_LESION.GRADE5],
//         trans : 'unit.brain_lesion.grade5',
//     },{
//         key : BRAIN_LESION[BRAIN_LESION.NEW01],
//         trans : 'unit.brain_lesion.new01',
//     },{
//         key : BRAIN_LESION[BRAIN_LESION.NEW02],
//         trans : 'unit.brain_lesion.new02',
//     },
// ]
var DEVICE_TYPE;
(function (DEVICE_TYPE) {
    DEVICE_TYPE[DEVICE_TYPE["ERROR"] = 0] = "ERROR";
    DEVICE_TYPE[DEVICE_TYPE["REBLESS_HOME"] = 1] = "REBLESS_HOME";
    DEVICE_TYPE[DEVICE_TYPE["REBLESS_PRO"] = 2] = "REBLESS_PRO";
})(DEVICE_TYPE || (DEVICE_TYPE = {}));
const DEVICE_TYPE_TRANS = [
    {
        key: DEVICE_TYPE[DEVICE_TYPE.ERROR],
        trans: 'device_type.error',
    }, {
        key: DEVICE_TYPE[DEVICE_TYPE.REBLESS_HOME],
        trans: 'device_type.rebless_home',
    }, {
        key: DEVICE_TYPE[DEVICE_TYPE.REBLESS_PRO],
        trans: 'device_type.rebless_pro',
    }
];
var MMT_GRADE;
(function (MMT_GRADE) {
    MMT_GRADE[MMT_GRADE["GRADE_0"] = 0] = "GRADE_0";
    MMT_GRADE[MMT_GRADE["GRADE_1"] = 1] = "GRADE_1";
    MMT_GRADE[MMT_GRADE["GRADE_2_NEG"] = 2] = "GRADE_2_NEG";
    MMT_GRADE[MMT_GRADE["GRADE_2"] = 3] = "GRADE_2";
    MMT_GRADE[MMT_GRADE["GRADE_2_POS"] = 4] = "GRADE_2_POS";
    MMT_GRADE[MMT_GRADE["GRADE_3_NEG"] = 5] = "GRADE_3_NEG";
    MMT_GRADE[MMT_GRADE["GRADE_3"] = 6] = "GRADE_3";
    MMT_GRADE[MMT_GRADE["GRADE_3_POS"] = 7] = "GRADE_3_POS";
    MMT_GRADE[MMT_GRADE["GRADE_4_NEG"] = 8] = "GRADE_4_NEG";
    MMT_GRADE[MMT_GRADE["GRADE_4"] = 9] = "GRADE_4";
    MMT_GRADE[MMT_GRADE["GRADE_4_POS"] = 10] = "GRADE_4_POS";
    MMT_GRADE[MMT_GRADE["GRADE_5"] = 11] = "GRADE_5";
})(MMT_GRADE || (MMT_GRADE = {}));
const MMT_GRADE_TRANS = [
    {
        key: MMT_GRADE[MMT_GRADE.GRADE_0],
        trans: 'unit.MMT.grade_0',
    }, {
        key: MMT_GRADE[MMT_GRADE.GRADE_1],
        trans: 'unit.MMT.grade_1',
    }, {
        key: MMT_GRADE[MMT_GRADE.GRADE_2_NEG],
        trans: 'unit.MMT.grade_2_neg',
    }, {
        key: MMT_GRADE[MMT_GRADE.GRADE_2],
        trans: 'unit.MMT.grade_2',
    }, {
        key: MMT_GRADE[MMT_GRADE.GRADE_2_POS],
        trans: 'unit.MMT.grade_2_pos',
    }, {
        key: MMT_GRADE[MMT_GRADE.GRADE_3_NEG],
        trans: 'unit.MMT.grade_3_neg',
    }, {
        key: MMT_GRADE[MMT_GRADE.GRADE_3],
        trans: 'unit.MMT.grade_3',
    }, {
        key: MMT_GRADE[MMT_GRADE.GRADE_3_POS],
        trans: 'unit.MMT.grade_3_pos',
    }, {
        key: MMT_GRADE[MMT_GRADE.GRADE_4_NEG],
        trans: 'unit.MMT.grade_4_neg',
    }, {
        key: MMT_GRADE[MMT_GRADE.GRADE_4],
        trans: 'unit.MMT.grade_4',
    }, {
        key: MMT_GRADE[MMT_GRADE.GRADE_4_POS],
        trans: 'unit.MMT.grade_4_pos',
    }, {
        key: MMT_GRADE[MMT_GRADE.GRADE_5],
        trans: 'unit.MMT.grade_5',
    }
];
var REPORT_SECTION_ITEM;
(function (REPORT_SECTION_ITEM) {
    REPORT_SECTION_ITEM[REPORT_SECTION_ITEM["ROM_MONITORING"] = 0] = "ROM_MONITORING";
    REPORT_SECTION_ITEM[REPORT_SECTION_ITEM["CHIEF_COMPLAIN"] = 1] = "CHIEF_COMPLAIN";
    REPORT_SECTION_ITEM[REPORT_SECTION_ITEM["EXPERT_OPINION"] = 2] = "EXPERT_OPINION";
})(REPORT_SECTION_ITEM || (REPORT_SECTION_ITEM = {}));
var AGREEMENT;
(function (AGREEMENT) {
    AGREEMENT[AGREEMENT["TERM_OF_USE"] = 0] = "TERM_OF_USE";
})(AGREEMENT || (AGREEMENT = {}));
var BROWSER;
(function (BROWSER) {
    BROWSER[BROWSER["DEFAULT"] = 0] = "DEFAULT";
    BROWSER[BROWSER["CHROME"] = 1] = "CHROME";
    BROWSER[BROWSER["EDGE"] = 2] = "EDGE";
    BROWSER[BROWSER["SAFARI"] = 3] = "SAFARI";
    BROWSER[BROWSER["FIREFOX"] = 4] = "FIREFOX";
    BROWSER[BROWSER["SAMSUNG_BROWSER"] = 5] = "SAMSUNG_BROWSER";
})(BROWSER || (BROWSER = {}));
module.exports = { HTTP_METHOD, EXERCISE_MODE, EXERCISE_STATUS, EXERCISE_RES_STATUS, POSITION, POSITION_TRANS,
    DIRECTION, DIRECTION_TRANS, EQUIPMENT, GENDER_TRANS, AGREEMENT, DEVICE_TYPE,
    DEVICE_TYPE_TRANS, MMT_GRADE, MMT_GRADE_TRANS, REPORT_SECTION_ITEM, BROWSER };
